import { render, staticRenderFns } from "./downloader.vue?vue&type=template&id=1df2d2f8&scoped=true"
import script from "./downloader.vue?vue&type=script&lang=js"
export * from "./downloader.vue?vue&type=script&lang=js"
import style0 from "./downloader.vue?vue&type=style&index=0&id=1df2d2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df2d2f8",
  null
  
)

export default component.exports